import './AV.alytics'
function sendAnalytics(eventName){
    var analytics = AV.analytics({
        // 设置 AppId
        appId: 'Wuy4PbIr9XY4GgIMVW6lonDN-gzGzoHsz',
        // 设置 AppKey
        appKey: 'RBS0derfTtgdYoSR91otRSEK',
        // 你当前应用或者想要指定的版本号（自定义）
        // version: '1.8.6',

        // 你当前应用的渠道或者你想指定的渠道（自定义）
        channel: 'APP帮助页面'
    });
    analytics.send({

        // 事件名称
        event: eventName,
        // // 事件属性，任意数据
        // attr: {
        //     testa: 123,
        //     testb: 'abc'
        // },
  
        // // 该事件持续时间（毫秒）
        // duration: 6000
    }, function(result) {
        if (result) {
            console.log('统计数据发送成功:',result);
        }
    });
}
export default sendAnalytics